"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatEmissionText = formatEmissionText;
const vehicleKey_1 = require("../utils/vehicleKey");
const constants_1 = require("./constants");
const mustacheRenderer_1 = require("./renderer/mustacheRenderer");
const utils_1 = require("./utils");
function formatEmissionText(resources, vehicleType, fuelEntry) {
    var _a, _b;
    let emissionNedc;
    let emissionWltp;
    const fuelWithEmissions = (0, utils_1.getFuelWithEmissions)(fuelEntry);
    if (fuelWithEmissions) {
        emissionNedc = (0, utils_1.getConsumptionOrEmissionNumericValue)((_a = fuelWithEmissions === null || fuelWithEmissions === void 0 ? void 0 : fuelWithEmissions.emission) === null || _a === void 0 ? void 0 : _a.co2, "NEDC", "combined");
        emissionWltp = (0, utils_1.getConsumptionOrEmissionNumericValue)((_b = fuelWithEmissions === null || fuelWithEmissions === void 0 ? void 0 : fuelWithEmissions.emission) === null || _b === void 0 ? void 0 : _b.co2, "WLTP", "combined");
    }
    const view = {
        emission: {
            wltp: {
                combined: emissionWltp,
            },
            nedc: {
                combined: emissionNedc,
            },
            combined: emissionNedc !== undefined ? emissionNedc : emissionWltp
        },
        footnote: {
            reference: `{${constants_1.FOOTNOTE_REFERENCE}}`,
        },
    };
    if (!vehicleType) {
        return undefined;
    }
    const translationKey = `vue.emission.combined.${(0, vehicleKey_1.getVehicleKeyForVehicleType)(vehicleType)}`;
    return (0, mustacheRenderer_1.substituteTemplate)(resources.get(translationKey), view);
}
